import React from "react";
import { HeroScene } from "../components/HeroScene";
import { FeaturesStrip } from "../components/FeaturesStrip";
import { PricingSection } from "../components/PricingSection";
import { HardwareShowcase } from "../components/HardwareShowcase";
import { UptimeStatus } from "../components/UptimeStatus";
import { FinalCTA } from "../components/FinalCTA";
import { PageLayout } from "../components/PageLayout";

export const HomePage = () => {
  return (
    <PageLayout title="OptiShield X | Hosting Premium">
      <HeroScene />
      <FeaturesStrip />
      <PricingSection />
      <HardwareShowcase />
      <UptimeStatus />
      <FinalCTA />
    </PageLayout>
  );
};
